import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Bulto } from "src/app/models/Dte/Exportacion/Bulto";
import { CodigosAduana } from "src/app/models/Dte/Exportacion/CodigosAduana";
import { TipoBulto } from "src/app/models/Dte/Exportacion/TipoBulto";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
	selector: "app-packages-list",
	templateUrl: "./packages-list.component.html",
	styleUrls: ["./packages-list.component.scss"],
})
export class PackagesListComponent implements OnInit, OnChanges {
	public packagesForm: FormGroup;
	public packagesArray: FormArray;
	private bultoItemFormGroup: FormGroup;
	private packagesList: Bulto[] = [];
	public codigoTipoBultoSource: TipoBulto[] = [];
	private codigosAduana: CodigosAduana;
	@Input() bultosGuardados: Bulto[] | null = null;
	@Output() packageListEmitter: EventEmitter<any> = new EventEmitter<any>();
	private restaurandoValores: boolean = false;
	private bultosPendientes: Bulto[] | null = null;

	constructor(private formBuilder: FormBuilder, private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.codigosAduana = this.localStorage.getCodigosAduana();
		this.codigoTipoBultoSource = this.codigosAduana.tipoBultos;
		this.sortAlphabeth(this.codigoTipoBultoSource, "descripcion");
		this.setArray();
		this.bultosPendientes = this.bultosGuardados;
		this.replicarBultosDesdeInput();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.bultosGuardados) {
			this.bultosPendientes = changes.bultosGuardados.currentValue ?? null;
			if (this.packagesForm) {
				this.replicarBultosDesdeInput();
			}
		}
	}

	setArray() {
		this.packagesForm = this.formBuilder.group({
			packsArray: this.formBuilder.array([this.newPackageForm()]),
		});
	}

	newPackageForm(): FormGroup {
		return this.formBuilder.group({
			codigotipoBulto: [, Validators.required],
			cantidadBulto: [, Validators.required],
			marcas: [],
			idContainer: [],
			sello: [],
			emisorSello: [],
		});
	}

	addPackageForm() {
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		if (currentArray.length < 10) {
			let newPackageForm = this.newPackageForm();
			currentArray.push(newPackageForm);
		}
	}

	removePackageForm(i) {
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		if (currentArray.length > 1) {
			currentArray.removeAt(i);
		} else {
			currentArray.reset();
		}
		this.submit();
	}

	submit() {
		if (!this.packagesForm) {
			return;
		}
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		if (!this.packagesForm.valid) {
			this.packagesList = [];
			if (!this.restaurandoValores) {
				this.packageListEmitter.emit(this.packagesList);
			}
			return;
		}

		this.packagesList = [];
		currentArray.controls.forEach((formGroupItem, index) => {
			const formGroup = formGroupItem as FormGroup;
			const tipoBulto: TipoBulto = formGroup.controls.codigotipoBulto.value;
			if (!tipoBulto) {
				return;
			}
			const exportPackage = new Bulto();
			exportPackage.codigoTipoBulto = tipoBulto.codigoSii;
			exportPackage.tipoBultoId = tipoBulto.tipoBultoId;
			exportPackage.nombreTipoBulto = tipoBulto.descripcion;
			exportPackage.cantidadBultos = formGroup.controls.cantidadBulto.value;
			exportPackage.marcas = formGroup.controls.marcas.value;
			exportPackage.idContainer = formGroup.controls.idContainer.value;
			exportPackage.sello = formGroup.controls.sello.value;
			exportPackage.emisorSello = formGroup.controls.emisorSello.value;
			exportPackage.localIndex = index + 1;
			this.packagesList.push(exportPackage);
		});

		if (!this.restaurandoValores) {
			this.packageListEmitter.emit(this.packagesList);
		}
	}

	private replicarBultosDesdeInput(): void {
		if (!this.packagesForm) {
			return;
		}
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		const datos = this.bultosPendientes ?? null;
		this.restaurandoValores = true;
		while (currentArray.length > 0) {
			currentArray.removeAt(0);
		}
		if (datos && datos.length > 0) {
			datos.forEach((bulto) => {
				const form = this.newPackageForm();
				const tipo = this.obtenerTipoBultoGuardado(bulto);
				form.patchValue(
					{
						codigotipoBulto: tipo ?? null,
						cantidadBulto: bulto.cantidadBultos,
						marcas: bulto.marcas,
						idContainer: bulto.idContainer,
						sello: bulto.sello,
						emisorSello: bulto.emisorSello,
					},
					{ emitEvent: false }
				);
				currentArray.push(form);
			});
		} else {
			currentArray.push(this.newPackageForm());
		}
		this.submit();
		this.restaurandoValores = false;
		this.bultosPendientes = null;
	}

	private obtenerTipoBultoGuardado(bulto: Bulto): TipoBulto | undefined {
		if (!bulto) {
			return undefined;
		}
		return this.codigoTipoBultoSource.find((tipo) => (bulto.tipoBultoId !== undefined && tipo.tipoBultoId === bulto.tipoBultoId) || (bulto.codigoTipoBulto !== undefined && tipo.codigoSii === bulto.codigoTipoBulto));
	}

	sortAlphabeth(list: any[], propertyName: string) {
		list.sort(function (a, b) {
			return a[propertyName].localeCompare(b[propertyName]);
		});
	}
}
